import React from "react";
import { Link } from "react-router-dom";
import { Button, Container, Card, Row, Col } from "react-bootstrap";

export default function Unauthorized() {
    return (
        <div 
            className="min-vh-100 d-flex align-items-center"
            style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: "20px"
            }}
        >
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col xs={12} md={8} lg={6}>
                        <Card className="shadow-lg border-0 rounded-4 overflow-hidden">
                            <Card.Body className="p-5 text-center">
                                {/* Icon */}
                                <div 
                                    className="d-inline-flex align-items-center justify-content-center mb-4 mx-auto"
                                    style={{
                                        width: "120px",
                                        height: "120px",
                                        background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)",
                                        borderRadius: "50%",
                                        animation: "pulse 2s infinite"
                                    }}
                                >
                                    <span style={{ fontSize: "3.5rem", color: "white" }}>🚫</span>
                                </div>

                                <h1 className="display-5 fw-bold mb-3" style={{ color: "#2d3748" }}>
                                    Access Denied
                                </h1>

                                <p className="text-muted mb-4">
                                    You don't have permission to access this page.
                                </p>

                                <div className="alert alert-light border rounded-3 mb-5">
                                    <p className="mb-0">
                                        If you believe this is an error, please contact your system administrator 
                                        or support team for assistance.
                                    </p>
                                </div>

                                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                                    <Link to="/" className="text-decoration-none">
                                        <Button 
                                            variant="primary" 
                                            size="lg"
                                            className="rounded-pill px-4 py-3 shadow-sm"
                                            style={{
                                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                border: "none",
                                                minWidth: "200px"
                                            }}
                                        >
                                            🏠 Go Back Home
                                        </Button>
                                    </Link>
                                    
                                    <Button 
                                        variant="outline-primary" 
                                        size="lg"
                                        className="rounded-pill px-4 py-3"
                                        onClick={() => window.history.back()}
                                    >
                                        ↩️ Return to Previous Page
                                    </Button>
                                </div>

                                <div className="mt-5 pt-4 border-top">
                                    <small className="text-muted">
                                        Error Code: 403 | Unauthorized Access
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <style>{`
                @keyframes pulse {
                    0% {
                        box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);
                    }
                    70% {
                        box-shadow: 0 0 0 15px rgba(255, 107, 107, 0);
                    }
                    100% {
                        box-shadow: 0 0 0 0 rgba(255, 107, 107, 0);
                    }
                }
            `}</style>
        </div>
    );
}